import { render, staticRenderFns } from "./LimiteAssinatura.vue?vue&type=template&id=7757c29a"
import script from "./LimiteAssinatura.vue?vue&type=script&lang=js"
export * from "./LimiteAssinatura.vue?vue&type=script&lang=js"
import style0 from "./LimiteAssinatura.vue?vue&type=style&index=0&id=7757c29a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports